import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['updateintervals'])
export default class UpdateIntervals extends Component {

  constructor(props) {
    super(props)

    this.props.updateintervals.loadAllUpdateIntervals()
  }

  newUpdateInterval(row) {
    this.props.updateintervals.newUpdateInterval(row.name)
  }

  updateUpdateInterval(row, cellText, cellValue) {
    this.props.updateintervals.updateUpdateInterval(row.id, cellValue)
  }

  deleteUpdateInterval(id) {
    if (confirm('Are you sure you want to delete this Update Interval?')) {
      this.props.updateintervals.deleteUpdateInterval(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteUpdateInterval(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newUpdateInterval.bind(this)
    }

    const updateIntervalsTable = (
      <BootstrapTable
          data={ this.props.updateintervals.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateUpdateInterval.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Update Intervals" content={ updateIntervalsTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/updateintervals.js